import styled from '@emotion/styled';
import React, {useCallback, useMemo} from 'react';
import {EAutocompleteOption} from 'webapp-lib/Components';

import {useMasterdata} from '_/hooks/useMasterdata';

export const useEventTagColors = (): {
  getRandomColor: () => string;
  colorAutocompleteOptions: EAutocompleteOption[];
} => {
  const {tags: allTags} = useMasterdata();

  const colors = useMemo(() => allTags.map((t) => t.colorHex), [allTags]);

  const getRandomColor = useCallback(
    () => colors[Math.floor(Math.random() * colors.length)],
    [colors]
  );

  const colorAutocompleteOptions: EAutocompleteOption[] = useMemo(
    () =>
      colors.map((color) => ({
        value: color,
        displayText: color,
        Icon: <ColorCircle color={color} />,
      })),
    [colors]
  );

  return {getRandomColor, colorAutocompleteOptions};
};

const ColorCircle = styled.span<{color: string}>`
  width: var(--tags-size-large);
  height: var(--tags-size-large);
  border-radius: 50%;
  background-color: ${({color}): string => color};
`;
